// @ts-nocheck
import LauncherContainer from 'components/launcher/Launcher.container';
import NotificationsContainer from 'components/notifications/Notifications.container';
import QrcodeContainer from 'components/qrcode/Qrcode.container';
import FaqContainer from 'components/faq/Faq.container';
import ProfileContainer from 'components/profile/Profile.container';
import { useInitProvider } from 'providers/InitProvider';
import React, { useState } from 'react';
// import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import { Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import Header from 'components/Header';
import Workspace from 'components/Workspace/Workspace';
import { stateErrorLogout } from 'components/errors/stateError';
import { DARK, LIGHT, SAME_TAB, SAME_WINDOW } from 'lib/config';
import { useLauncherStrategyProvider } from 'lib/launchStrategies/LauncherStrategyProvider';
import { useTranslation } from 'react-i18next';
import { ErrorPage } from 'requiro-ui-theme';
import { IApp } from 'types';

const findIn = (list: IApp[]) => (code: string) =>
  list.find((app) => app.code === code);

const AppHeader = () => {
  const initData = useInitProvider();

  const { dump, theme: themeProvider } = initData;

  const thisTheme = useTheme();

  const matches = useMediaQuery(thisTheme.breakpoints.down('sm'));

  const logo = themeProvider?.appshell?.logoPrimary
    ? themeProvider?.appshell?.logoPrimary
    : './assets/images/logo.svg';
  const logoMobile = themeProvider?.appshell?.logoPrimaryMobile
    ? themeProvider?.appshell?.logoPrimaryMobile
    : './assets/images/logo_mobile.svg';
  const logoWhite = themeProvider?.appshell?.logoSecondary
    ? themeProvider?.appshell?.logoSecondary
    : './assets/images/logo_white.svg';
  const logoWhiteMobile = themeProvider?.appshell?.logoSecondaryMobile
    ? themeProvider?.appshell?.logoSecondaryMobile
    : './assets/images/logo_white_mobile.svg';
  const [theme, setTheme] = useState('dark');
  const [brandImageSrc, setBrandImageSrc] = useState<string | null>(null);
  const [brandImageSrcOk, setBrandImageSrcOk] = useState<boolean>(false);
  const [logoSrc, setLogoSrc] = useState<string>(logo);
  const [logoSrcMobile, setLogoSrcMobile] = useState<string>(logoMobile);
  const [title, setTitle] = useState<string>('');
  const [flagError, setFlagError] = useState<boolean>(false);
  const [currentApp, setCurrentApp] = useState<IApp | null>(null);
  const { launchApplication, gotoCurrentAppHome } =
    useLauncherStrategyProvider();
  const hash = window.location.hash.substring(1);
  const { current, available } = dump?.workspace;

  const { t } = useTranslation();

  React.useEffect(() => {
    const { dump, amIUsingTheDefaultApp } = initData;

    const t = amIUsingTheDefaultApp() ? DARK : LIGHT;
    setTheme(t);

    // current app
    const app: IApp | null =
      findIn(dump.apps)(window.location.hash.substring(1)) || null;



    if (app) {
      const tempTitle =
        app.code !== dump.shell.defaultApplicationId ? app.label : null;
      setTitle(tempTitle);
      flagError && setFlagError(false);
    } else {
      setFlagError(true);
    }

    // logo
    amIUsingTheDefaultApp()
      ? setLogoSrc(logoWhite)
      : setLogoSrc(app ? app.icon : logo);

    // brand image
    amIUsingTheDefaultApp()
      ? setBrandImageSrc(logoWhite)
      : setBrandImageSrc(app && app.brandImage ? app.brandImage : null);

    // logo mobile
    amIUsingTheDefaultApp()
      ? setLogoSrcMobile(logoWhiteMobile)
      : setLogoSrcMobile(app ? app.icon : logoMobile);
  }, [initData.isDefaultApp, initData.dump, setTheme, initData, currentApp]);

  React.useEffect(() => {
    // check if brandImage exists
    if (brandImageSrc) {
      fetch(brandImageSrc).then(res => {
        if (res.status === 200) setBrandImageSrcOk(true)
      }).catch(err => {
        setBrandImageSrcOk(false)
      })
    }
  }, [brandImageSrc])

  const logoHandler = (data: IApp) => {
    if (data.target === SAME_TAB || data.target === SAME_WINDOW) {
      setCurrentApp(data);
    }
  };

  const gotoHomeHandler = () => {
    const defaultApp = findIn(initData.dump.apps)(
      initData.dump.shell.defaultApplicationId,
    );
    launchApplication(defaultApp);
  };

  const logoClickHandler = () => {
    gotoCurrentAppHome();
  };

  const isInternalApp = title && hash.toLowerCase() !== 'workspace';

  if (flagError) {
    return <ErrorPage {...stateErrorLogout} />;
  }

  return (
    <>
      <Header
        actions={[
          <LauncherContainer
            type={theme}
            key="LauncherContainer"
            logoHandler={logoHandler}
            gotoHomeHandler={gotoHomeHandler}
            workspaceSelected={!current && available?.length > 1}
          />,
          <NotificationsContainer
            type={theme}
            key="NotificationsContainer"
            workspaceSelected={!current && available?.length > 1}
          />,
          <QrcodeContainer type={theme} key="QrcodeContainer" />,
          <FaqContainer type={theme} key="FaqContainer" />,
          <ProfileContainer key="ProfileContainer" />,
        ]}
        logo={
          <div onClick={logoClickHandler} style={{ cursor: 'pointer' }}>
            {brandImageSrcOk ?
              <img src={brandImageSrc} alt={title} style={{ width: '100%', height: '100%' }} />
              :
              <>
                {hash.toLowerCase() !== 'account' ? (
                  matches ? (
                    <img src={logoSrcMobile} alt={title} />
                  ) : (
                    <img src={logoSrc} alt={title} />
                  )
                ) : null}
                {isInternalApp ? <Typography ml={2}>{title}</Typography> : null}
              </>
            }


          </div>
        }
        type={theme}
        isApp={isInternalApp}
      />
      {!current && available?.length > 1 ? <Workspace /> : null}
    </>
  );
};

export default AppHeader;
